const columns = {
  a: document.getElementById('column-a'),
  b: document.getElementById('column-b'),
  c: document.getElementById('column-c'),
};

const resetColumns = () => {
  Object.values(columns).forEach((column) => {
    column.classList.remove('expanded');
    column.style.flex = '1';
    column.classList.remove('hidden');

    const learnMoreButton = column.querySelector('.learn-more');
    if (learnMoreButton) {
      learnMoreButton.classList.remove('hidden');
    }

    const closeButton = column.querySelector('.close-button');
    if (closeButton) {
      closeButton.remove();
    }
  });
};

document.querySelectorAll('.learn-more').forEach((button) => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    const target = e.target.dataset.target;

    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    resetColumns();

    columns[target].classList.add('expanded');
    columns[target].style.flex = '2';

    if (!isMobile) {
      if (target === 'a') {
        columns['b'].classList.add('hidden');
      } else if (target === 'b') {
        columns['a'].classList.add('hidden');
      } else if (target === 'c') {
        columns['b'].classList.add('hidden');
      }
    }

    const remainingColumn = target === 'a' ? 'c' : target === 'b' ? 'c' : 'a';
    columns[remainingColumn].style.flex = '1';

    button.classList.add('hidden');

    const closeButton = document.createElement('button');
    closeButton.innerHTML = 'X';
    closeButton.classList.add(
      'absolute',
      'top-4',
      'right-4',
      'bg-white',
      'text-black',
      'px-4',
      'rounded-4xl',
      'close-button',
      'text-[26px]',
    );
    closeButton.addEventListener('click', () => {
      resetColumns();
    });

    if (!columns[target].querySelector('.close-button')) {
      columns[target].appendChild(closeButton);
    }
  });
});
